import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=1896714b&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=1896714b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896714b",
  null
  
)

export default component.exports